import { extractErrorMessage, httpClient } from '@/lib/api'
import { referralsTexts } from '../referrals.texts'
import type { GetReferralsResult, ReferralsApi } from './referrals-api.types'

export const prodReferralsApi: ReferralsApi = {
  async getReferrals(): Promise<GetReferralsResult> {
    try {
      const { data } = await httpClient.get('/api/partner/referrals')
      return { success: true, data: data.data }
    } catch (error: unknown) {
      return {
        success: false,
        error: extractErrorMessage(error, referralsTexts.dashboard.loadError),
      }
    }
  },
}
